import { useSirenEntity, sirenActions } from '~/utility/BinSentry-ui-utility';
import { useEffect, useState } from 'react';
import { getSiren } from '~/common/get-siren';

export function useFeeds({ organizationId }) {
  const [ feeds, setFeeds ] = useState([]);
  const [ loading, setLoading ] = useState(true);
  const { entity: organizationEntity } = useSirenEntity({ href: organizationId } );
  const feedsHref = organizationEntity?.getSubEntityByRel('https://api.binsentry.com/rel/v2/feeds')?.href;
  const { entity: feedsEntity } = useSirenEntity({ href: feedsHref });

  useEffect(() => {
    async function loadFeeds() {
      if (!feedsEntity) {
        setFeeds([]);
        return;
      }
      setLoading(true);
      setFeeds(await fetchFeeds(feedsEntity));
      setLoading(false);
    }
    loadFeeds();
  }, [feedsEntity]);

  return { feeds, feedsEntity, feedsHref, loading };
}

export function useFeedOptions({ organizationId }) {
  const { feeds, loading } = useFeeds({ organizationId });

  return {
    feedOptions: feeds.map((feed) => ({
      feedId: feed.getLinkByRel('self').href,
      name: `${feed.properties.feedType}${feed.properties.formulaId ? ` (${feed.properties.formulaId})` : ''}`,
    })),
    loading,
  };
}

export async function fetchFeeds(feedsEntity) {
  let feedEntities = [];
  const limitAction = feedsEntity.getAction('limit-feeds');
  let nextLink = sirenActions.parseAction(limitAction, { limit: 100 }).url;
  do {
    const entity = await getSiren(nextLink, { bypassCache: true });
    feedEntities.push(...entity.getSubEntitiesByRel('https://api.binsentry.com/rel/feed'));
    nextLink = entity.getLinkByRel('next')?.href;
  } while (nextLink);
  return feedEntities;
}
